"use client";

import Link from "next/link";
import { Button } from "@/components/ui/button";
import { useAuth } from "@/context/auth-context";

export function NotFoundActions() {
  const { user } = useAuth();

  const dashboardUrl = (() => {
    if (!user?.role) return null;
    const role = (user.role as string).toUpperCase();
    switch (role) {
      case "ADMIN":
        return "/admin/dashboard";
      case "TUTOR":
        return "/tutor";
      case "STUDENT":
        return "/student";
      case "EMPLOYEE":
        return "/employee/dashboard";
      case "ADVERTISER":
        return "/advertiser/dashboard";
      default:
        return null;
    }
  })();

  return (
    <div className="flex flex-col sm:flex-row gap-3 justify-center">
      <Button asChild>
        <Link href="/">Go home</Link>
      </Button>
      {dashboardUrl ? (
        <Button variant="outline" asChild>
          <Link href={dashboardUrl}>Dashboard</Link>
        </Button>
      ) : (
        <Button variant="outline" asChild>
          <Link href="/login">Log in</Link>
        </Button>
      )}
    </div>
  );
}
